<template>
  <v-layout wrap style="margin-top: 70px" align-center justify-center>
    <v-flex xs12 sm6 md6 v-if="packageItem" class="px-2" id="package_items">
      <v-card>
        <v-layout wrap class="pa-3">
          <!-- <v-flex xs12 class="title text-xs-center pa-2 selectedPackage">Selected Package:</v-flex> -->

          <v-flex xs12 class="title text-xs-center"><span class="selectedPackage">Selected Package:</span> {{packageItem.name}}</v-flex>

          <!-- <v-flex xs12 class="pt-3 text-xs-center">
            <p>{{packageItem.description}}</p>
          </v-flex> -->

          <!-- <v-flex xs12 class="pa-1 title text-xs-center">Features</v-flex>

           <v-flex xs12>
            <ul>
              <li v-for="(feature, index) in packageItem.features" v-bind:key="index">
                <v-icon>arrow_right</v-icon>
                {{feature}}
              </li>
            </ul>
          </v-flex> -->

          <v-flex xs12 class="mt-3 text-xs-center">
            Selected Option: {{selectedTime}} -@ {{selectedCurrency.toUpperCase()}} {{selectedCost}}
          </v-flex>

          <v-flex xs12 class="text-xs-center">
            <v-btn class="green darken-1" dark to="/vip_sonko/packages">
              <v-icon left>edit</v-icon>Change Package
            </v-btn>
          </v-flex>

          <v-flex xs12 class="text-xs-center">
            <v-btn v-if="selectedCost==0" class="blue darken-1" dark @click="makePayment">Subscribe</v-btn>
            <v-btn v-else class="blue darken-1" dark @click="makePayment">Make Payment</v-btn>
          </v-flex>
        </v-layout>
      </v-card>
    </v-flex>
    <v-flex xs12 class="text-xs-center iframe" style="display: none;" id="ipay_iframe">
      <v-card>
        <v-layout wrap class="pa-3">
          <v-flex xs12 class="title text-xs-center"><span class="selectedPackage">Selected Package:</span> {{packageItem.name}}</v-flex>
          <v-flex xs12 class="mt-3 text-xs-center">
            Selected Option: {{selectedTime}} -@ {{selectedCurrency.toUpperCase()}} {{selectedCost}}
          </v-flex>
          <iframe xs12 style="width: 100%;border: none;height: 400px;" name="ipay_iframe"></iframe>
          <v-flex xs12 class="text-xs-center" >
            <span class="profiletext">For Mpesa payments, WAIT until you see the message 'successful payment' above... then click</span>
            <v-btn class="blue darken-1" dark @click="gotoprofile">Go to my Profile</v-btn><br>
          </v-flex>
        </v-layout>
      </v-card>
    </v-flex>

    <app-snackbar ref="snackbar"></app-snackbar>
  </v-layout>
</template>


<script>
import { mapGetters } from "vuex";
import { host } from "@/common";
export default {
  name: "packagesList",
  computed: {
    ...mapGetters(["user"])
  },
  props: {
    packageItem: {
      type: Object,
      default: {}
    }
  },
  data() {
    return {
      row: null,
      column: null,
      radios: null,
      selectedTime: null,
      selectedCost: null,
      selectedDuration: null,
      selectedCurrency: null,
    };
  },
  methods: {
    makePayment() {
      const details = {
        userId: this.user._id,
        cost: parseInt(this.$route.query.cost),
        duration: parseInt(this.$route.query.duration),
        packageId: this.packageItem._id,
        optionId: this.$route.params.option,
        packageName: this.packageItem.name,
        packageOption: this.$route.query.time,
        currency: this.$route.query.currency,
        vip_package_type: this.packageItem.vip_package_type,
      };

      const cost = parseInt(this.$route.query.cost);

      const data = { data: JSON.stringify(details) };
      const self = this;
      
      // get expert subscription
      this.$store
        .dispatch("get", "/subscription/mysubscription/" + self.user._id)
        .then(res => {
          if (cost == 0) {
            if (res.subscription == null) {
              const res = this.$store
                .dispatch("post", { url: "/subscription/free", data })
                .then(res => {
                  if (res.state == true) {
                    localStorage.setItem("subscription", "subscribed");
                    self.$router.push("/vip_sonko/subscription/successful");
                  }
                });
            } else {
              self.$refs.snackbar.show("Your have already utilized your free subscription, you can only use it once.", "red");
            }
          } else {
            if (res.subscription == null) {
              const res = this.$store
              .dispatch("post", { url: "/payment/staging/", data })
              .then(res => {
                if (res.state == true) {
                  localStorage.setItem("subscription", "subscribed");
                  const paymentId = res.payment._id;
                  self.$store.dispatch("payment", paymentId).then(res => {
                  });
                }
              });
            } else {
              if(res.subscription.vip_package_type == 3 && this.packageItem.vip_package_type == 2) {
                self.$refs.snackbar.show("You can only Renew your current package under the current or a different time-frame or Upgrade your subscription to the next higher plan", "red");
              } else if (res.subscription.vip_package_type == 4 && (this.packageItem.vip_package_type == 2 || this.packageItem.vip_package_type == 3)) {
                self.$refs.snackbar.show("You can only Renew your current package under the current or a different time-frame or Upgrade your subscription to the next higher plan", "red");
              } else {
                const res = this.$store
                .dispatch("post", { url: "/payment/staging/", data })
                .then(res => {
                  if (res.state == true) {
                    const paymentId = res.payment._id;
                    self.$store.dispatch("payment", paymentId).then(res => {
                      //this.openTab(`${host}/web/system/subscription/${paymentId}`);
                      /*window.open(
                        `${host}/web/system/subscription/${paymentId}`,
                        "_blank"
                      );*/
                      /*self.$store
                        .dispatch("get", "/web/system/subscription/" + paymentId)
                        .then(res => {
                          console.log(res);
                        });*/
                    });
                  }
                });
              }
            }
          }
        });
      // end
      
    },
    openTab(url) {
      // Create link in memory
      var a = window.document.createElement("a");
      a.target = '_blank';
      a.href = url;

      // Dispatch fake click
      var e = window.document.createEvent("MouseEvents");
      e.initMouseEvent("click", true, true, window, 0, 0, 0, 0, 0, false, false, false, false, 0, null);
      a.dispatchEvent(e);
    },
    gotoprofile() {
      this.openTab(`${host}/#/vip_sonko/profile`);
      //this.$router.push('/expert/profile');
    }
  },
  created() {
    const time = this.$route.query.time;
    const cost = this.$route.query.cost;
    const duration = this.$route.query.duration;
    this.selectedTime = time;
    this.selectedCost = cost;
    this.selectedDuration = duration;
    this.selectedCurrency = this.$route.query.currency;
  }
};
</script>

<style scoped>
.options {
  border-bottom: 1px solid #eeeeee;
}

ul li {
  list-style: none;
}

.selectedPackage {
  color: orange;
}
.profiletext {
  color: red;
}
.iframe {
  position: absolute;
  top: 65px;
  left: 0px;
  bottom: 0px;
}
</style>